<template>
		<div class="home-page">
		<Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
      <div class="mission-content ac crfff">
        <div class="fs50 mt50">{{$t('GenerateImage')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-12nj5ib">
            <div style="">{{$t('generateTips1')}}<br /><br />{{$t('generateTips2')}}</div>
            <h6 class="css-po8uek wen-c mt50 ac">
                <strong class="fs40">{{$t('Prompt')}}</strong>
                <div class="mt30" style="font-size: 0.24rem">
                  {{$t('PromptTips1')}}<br />
                  {{$t('PromptTips2')}}<br />
                  {{$t('PromptTips3')}}
                </div>
              </h6>
          </div>
          <form class="auth-form mt30 css-6y7yrh">

            <div class="">
              <div class="css-1gzwcwv">
                <div class="custom-input">
                  <textarea :placeholder="$t('generateImageTips1')" v-model="description"></textarea>
                </div>
              </div>
              <div class="css-1gzwcwv">
                <div class="custom-input">
                  <input
                    type="text"
                    :placeholder="$t('generatePromptsTips1')"
                    v-model="negativePrompt"
                  />
                </div>
              </div>
            </div>
            <div class="css-1a2chew">
              <div class="submit-button-container">
                <button type="button" class="submit-button" @click="creatImage">
                  <p class="submit-button-text">{{$t('Generate')}}</p>
                </button>
                <div class="background-div"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="ac">
          <button style="width: calc(100% - 100px);" @click="creatImage" class="button"><img width="20" src="../../static/images/Generate-icon.png"><strong>{{$t('Generate')}}</strong></button>
      </div>
      <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
        <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--        <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>-->
      </div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 0.5rem;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{$t('downTips1')}}</div>
                <div style="margin-bottom: 20px;">{{detail.title}}</div>
               <img :src="detail.url" style="width:80%;border: 1px solid #7827d3;border-radius: 20px;" />
                <div class="img-tools">
                  <div class="ac mt20">
                    <div class="input-item mt50" style="margin-bottom: 20px;">
                      <div class="input-item2">
                        <input class="input" v-model="detail.url" disabled type="" placeholder="">
                      </div>
                    </div>
                    <button class="button fw7" style="width: 100%;" id="copycode" :data-clipboard-text="detail.url" @click="copy"  v-if="detail.url"><img style="margin-left: 10px;width: 0.35rem" src="../../static/images/copy1.png" /> {{$t('copyLink')}}</button>
                  </div>
                </div>
              </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        invited_code:'',
        invitedAlert:'',
        imageShow:false,
        detail:{},
        description:'',
        negativePrompt:'',
        score:'',
        isShow:'bur',
        options:{
          main: {},
          cate: {},
          choices: {}
        },
        isMain:'Living_Organism',
        isCate:'Human',
        ids:[],
        numIds:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      }
    },
	watch: {

	},
	computed:{
	},
  mounted() {
    let that = this;
  },
  created(){
    this.getHome();
    this.getOptions();
    if(localStorage.getItem('lang')){
      this.isShow = localStorage.getItem('lang')
    }
  },
  methods: {
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getArr(key,item2,index){
      console.log(index)
      console.log(this.numIds[index])
      if(this.ids.indexOf(key) == -1){
        if(item2.single=='yes'){
          if(this.ids.indexOf(this.numIds[index][0]) !== -1){
            this.ids = this.ids.filter(item => item !== this.numIds[index][0]);
          }
          this.numIds[index].splice(-1, 1);
          if(this.numIds[index].length>=1){
            return;
          }
          this.numIds[index].push(key)
        }
        this.ids.push(key)
      }else{
        this.ids = this.ids.filter(item => item !== key);
        this.numIds[index] = this.numIds[index].filter(item => item !== key);
      }
    },
    getCate(key){
      this.ids = []
      this.numIds = [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      this.isCate = key
    },
    getMain(key){
      this.isMain = key
      this.ids = []
      this.numIds = [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      if(key=='Non_living_Entity'){
        this.isCate = 'Architecture'
      }else{
        this.isCate = 'Human'
      }

    },
		back(){
      this.$router.go(-1);
		},
    getOptions(){
      let that =this;
      //that.$parent.loadModal(true);
      that.$api.get('/api/index/get_mm_tags',null,r =>{
      	that.$parent.returnCode(r,function(){
          that.options=r.data
        });
      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
    creatImage() {
      var that = this;
      let data = {}
      if(that.isShow=='bur'){
        console.log(that.ids)
          data = {
            ids:that.ids
          }
      }else{
        data = {
          description:that.description,
          negativePrompt:that.negativePrompt
        }
        if (!that.description) {
          that.$utils.alertText(that.$t('generateImageTips1'),50);
          return;
        }
        console.log(that.negativePrompt)
        if (!that.negativePrompt) {
          that.$utils.alertText(that.$t('generatePromptsTips1'),50);
          return;
        }
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/art_image',data,r =>{
        if(r.code==0){
          that.description = ''
          that.negativePrompt = ''
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,50);
          return;
        }
        that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.$refs.imgDialog.showMaskFun();
            that.getHome();
            that.imageShow = true
            that.description = ''
            that.negativePrompt = ''
            that.detail = r.data
          });
        })
    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    },
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'));
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    }
	}
}
</script>
<style>
  .table-cate{flex-wrap: wrap;border: none;width:100%}
  .table-cate span{border:0.02rem solid #b03fa1;margin: 0 0.1rem 0.2rem;width: calc(50% - 0.2rem);border-radius: 0.1rem !important;padding:0.15rem 0.1rem}
  .tab-content{flex-wrap: wrap;margin: 0.2rem 0 0;text-align: left;border-top: 0.02rem solid #6240da;padding-top: 0.2rem;}
  .tab-c{background: #001586;margin: 0.1rem;color: #ffffff;padding:5px 0.1rem;display: inline-block;border: 1px solid #6240da;border-radius: 0.1rem;}
  .tab-c.active{background: #b03fa1;}
</style>



// WEBPACK FOOTER //
// src/page/generateImage.vue